"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var ComparisonTableWithinContext_1 = require("./ComparisonTableWithinContext");
var withContext_1 = require("../../utils/hoc/withContext");
/* tslint:disable:jsdoc-format */
/**
 * The `ComparisonTable` component visualizes a tariff comparison table and can be
 * used in the `reduced` and the `rich` variant.
 *
 * The table should be specified by a table head (`thead`) and a table body (`tbody`).
 * At least two columns must be defined: The first column should describe
 * the tariff details that will be compared. The second and subsequent columns the specific
 * values for each compared tariff.
 *
 * Only one tariff will be displayed on small screens and the user can switch
 * to other tariffs via tabs or another mechanism (e.g. `Radio`-elements) provided by the
 * surrounding application.
 *
 * For large tables (`tbody` bigger than `thead`), the table head of a `rich` table is sticky
 * and will be visible even upon scrolling.
 *
 * Example:
 *
```html
<ComparisonTable>
    <thead>
        <tr>
            <th />
            <th>Tariff A</th>
            <th>Tariff B</th>
        </tr>
        <tr>
            <th scope="row">Premium</th>
            <td><Price value={1.23}/></td>
            <td><Price value={3.45}/></td>
        </tr>
    </thead>
    <tbody>
        <tr>
            <th scope="row">Insurance sum</th>
            <td>10 EUR</td>
            <td>20 EUR</td>
        </tr>
    </tbody>
    <tbody>
        <tr>
            <th scope="rowgroup" colSpan={3}>Additional options</th>
        </tr>
        <tr>
            <th scope="row">Chief physician</th>
            <td>yes</td>
            <td>no</td>
        </tr>
    </tbody>
</ComparisonTable>
```
 *
 * On small screens a table head `<thead>` element must exist and the navigation tab content
 * is defined by the first `<th>` element content of the first `<tr>` element.
 *
 * Other props are passed through to the `table` element.
 */
exports.ComparisonTable = withContext_1.withErgoElementsContext('ComparisonTableProps', ComparisonTableWithinContext_1.ComparisonTableWithinContext);
exports.default = exports.ComparisonTable;
__export(require("./ComparisonTableWithinContext"));
//# sourceMappingURL=ComparisonTable.js.map
